import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "lz-experts-data" }
const _hoisted_3 = { class: "h" }
const _hoisted_4 = { class: "lz-experts-social" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "external" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "external" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "external" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "external" }
const _hoisted_16 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'LzExpertsItem',
  props: {
    firstname: {},
    lastname: {},
    picture: {},
    email: {},
    description: {},
    socialXing: {},
    socialLinkedin: {},
    socialX: {},
    socialGithub: {},
    employeeEmail: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: _ctx.picture,
      class: "lz-experts-img"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.firstname) + " " + _toDisplayString(_ctx.lastname), 1),
      _createElementVNode("p", null, [
        _renderSlot(_ctx.$slots, "description")
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_4, [
          (_ctx.socialLinkedin !== '')
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("a", {
                    class: "fab fa-linkedin-in",
                    href: `${_ctx.socialLinkedin}`,
                    target: "_blank"
                  }, null, 8, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.socialXing !== '')
            ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createElementVNode("a", {
                    class: "fab fa-xing",
                    href: `${_ctx.socialXing}`,
                    target: "_blank"
                  }, null, 8, _hoisted_10)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.socialX !== '')
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, [
                  _createElementVNode("a", {
                    class: "fab fa-x-twitter",
                    href: `${_ctx.socialX}`,
                    target: "_blank"
                  }, null, 8, _hoisted_13)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.socialGithub !== '')
            ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _createElementVNode("a", {
                    class: "fab fa-github",
                    href: `${_ctx.socialGithub}`,
                    target: "_blank"
                  }, null, 8, _hoisted_16)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})